export const BASE_URL = process.env.VUE_APP_BASE_URL;
export const CMS_BASE_PATH = "https://quantrom.com/blog";
